import i18n from 'i18next'
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector'
import langEsCl from '../locales/es/esCl.json'
import langEsPe from '../locales/es/esPe.json'
import langEn from '../locales/en/en.json'
import langPt from '../locales/pt/pt.json'

// Formularios - generico
import langEsForms from '../locales/forms/es.json'
import langPtForms from '../locales/forms/pt.json'
import langEnForms from '../locales/forms/en.json'

// Formularios - Sonda
import langEsSonda from '../locales/forms/sonda/es.json'
import langPtSonda from '../locales/forms/sonda/pt.json'
import langEnSonda from '../locales/forms/sonda/en.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v3',
    resources: {
      esCHI: {
        translations: langEsCl,
        forms: langEsForms,
        formsSonda: langEsSonda
      },
      esCR: {
        translations: langEsCl,
        forms: langEsForms,
        formsSonda: langEsSonda
      },
      esPER: {
        translations: langEsPe,
        forms: langEsForms,
        formsSonda: langEsSonda
      },
      enCHI: {
        translations: langEn,
        forms: langEnForms,
        formsSonda: langEnSonda
      },
      enCR: {
        translations: langEn,
        forms: langEnForms,
        formsSonda: langEnSonda
      },
      enPER: {
        translations: langEn,
        forms: langEnForms,
        formsSonda: langEnSonda
      },
      ptCHI: {
        translations: langPt,
        forms: langPtForms,
        formsSonda: langPtSonda
      },
      ptPER: {
        translations: langPt,
        forms: langPtForms,
        formsSonda: langPtSonda
      }
    },

    detection: {
      //order: ['navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage','sessionStorage']
    },

    fallbackLng: "esCHI",
    debug: true,

    ns: ["translations", "forms", "formsSonda"],

    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
      formatSeparator: ","
    },

    react: {
      wait: true
    }
  })

export default i18n
